export default "__VITE_ASSET__Dw$Jh3Q5__"